import type { AxiosProgressEvent, AxiosResponse } from "axios";

import { AxiosInstance } from "api";

interface ImageData {
  avatar: {
    large_avatar: {
      url: string;
    };
    medium_avatar: {
      url: string;
    };
    small_avatar: {
      url: string;
    };
  };
}

export const updateImage = (
  file: FormData,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
): Promise<AxiosResponse<ImageData>> =>
  AxiosInstance.post(`/users/avatar`, file, {
    headers: {
      "Content-type": "multipart/form-data",
    },
    onUploadProgress,
  });
